import { createAction, props } from '@ngrx/store';

const feature = '[Signup Terms and Conditions]';

export const setAcceptTermsAndConsentMarketing = createAction(
  `${feature} set accept terms and consent marketing`,
  props<{ hasAcceptedTerms: boolean; hasMarketingConsented: boolean }>()
);
